import { OverlayTrigger } from "react-bootstrap";
import { TooltipStandard } from "../TooltipStandard";

//Credit to Jose from his landing page toggle on the dashboard page and all the classes he set up for this in the css file.
export const ToggleSwitch = ({
  tooltipMessage,
  label,
  checked,
  onClick,
  disabled,
  labelPaddingOverride = ".5rem", // set on padding left to get rid of extra space left over on right side. I don't know why.
}) => {
  return (
    <OverlayTrigger
      placement="top"
      show={!tooltipMessage ? false : undefined}
      overlay={
        <TooltipStandard id="button-tooltip">{tooltipMessage}</TooltipStandard>
      }
    >
      <button
        className="tw-inline-flex tw-items-center tw-border-0 tw-bg-transparent tw-outline-none tw-cursor-pointer tw-p-0 focus:tw-outline-none"
        onClick={onClick}
        disabled={disabled}
      >
        <span className="tw-mt-1 tw-mr-2">{label}</span>
        <div className="custom-control custom-switch custom-switch-md tw-cursor-pointer">
          <input
            type="checkbox"
            className="custom-control-input tw-cursor-pointer tw-hidden"
            checked={checked}
            onChange={() => {}} //onChange prop not triggering so removed for now. Using onClick on the outer button instead
          />

          <label
            className="custom-control-label tw-cursor-pointer"
            style={{
              paddingLeft: labelPaddingOverride,
            }}
            htmlFor="toggle-previous-landing-page"
          />
        </div>
      </button>
    </OverlayTrigger>
  );
};
